import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Snackbar, TextField, Typography } from "@material-ui/core";

// Icon
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";

// components
import ToolTipButton from "../../components/ToolTipButton";
import Image from "../../components/Image";
import { storage } from "../../firebase/firebase";
import { create, update } from "../../db";
import { useStateValue } from "../../store/provider";
import { permissionError } from "../../util/alert";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  closeDialog: {
    position: "absolute",
    right: "10px",
    top: "5px",
  },
  bottom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  appBox: {
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0",
    alignItems: "end",
  },
  appField: {
    margin: 5,
  },
  head: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 10,
    alignItems: "center",
    flexDirection: "column",
  },
}));

const AppDialog = (props) => {
  const classes = useStyles();
  const [{ admin }] = useStateValue();

  const app = {
    index: 0,
    name: "",
    icon: "",
    url: "",
    nameError: "Required",
    iconError: "choose an image",
    urlError: "Required",
  };

  const [isImageUploading, setIsImageUploading] = useState(false);
  const [open, setOpen] = useState(false);
  const [appIndexCounter, setAppIndexCounter] = useState(0);
  const [name, setName] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [apps, setApps] = useState([]);

  const [errors, setErrors] = useState({
    name: "",
    app: "",
    image: "",
  });

  useEffect(
    () => () => {
      if (!open && !props.edit) {
        setErrors({
          name: "",
          app: "",
          image: "",
        });
        setName("");
        setImagePath("");
        setApps([]);
        setAppIndexCounter(0);
      }
    },
    [open, props.edit]
  );

  useEffect(() => {
    if (props.edit) {
      setName(props.app.name);
      setImagePath(props.app.icon);
      setApps(props.app.apps);
      setAppIndexCounter(props.app.apps.length);
    }
  }, [props.edit]);

  const handleChangeApp = (index, event) => {
    const newData = [...apps];

    let nameError = newData[index].nameError,
      urlError = newData[index].urlError;

    switch (event.target.name) {
      case "name":
        nameError = event.target.value !== "" ? "" : "Required";
        break;
      case "url":
        urlError = event.target.value !== "" ? "" : "Required";
        break;
      default:
        break;
    }

    newData[index] = {
      ...newData[index],
      [event.target.name]: event.target.value,
      nameError,
      urlError,
    };

    setApps(newData);
  };

  const handleAddApp = () => {
    if (apps.length !== 0) {
      const lastApp = apps[apps.length - 1];

      if (
        lastApp.nameError !== "" ||
        lastApp.iconError !== "" ||
        lastApp.urlError !== ""
      ) {
        return setErrors({
          ...errors,
          app: "Fill all the field of previous app!",
        });
      }
    }

    setApps([
      ...apps,
      {
        ...app,
        index: appIndexCounter,
      },
    ]);
    setAppIndexCounter(appIndexCounter + 1);
  };

  const handleRemoveApp = (index) => {
    // console.log(index);
    setApps([...apps].filter((app) => app.index !== index));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (!admin.flag) return permissionError();
    setOpen(true);
  };

  const handleInputFileChange = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleAppImageChange = (index, e) => {
    if (e.target.files[0]) {
      const fileName = new Date().getTime() + e.target.files[0].name;
      setIsImageUploading(true);
      const uploadTask = storage
        .ref(`/images/${fileName}`)
        .put(e.target.files[0]);
      uploadTask.on(
        "state_changed",
        () => {},
        (err) => console.log(err),
        async () => {
          const url = await storage
            .ref("images")
            .child(fileName)
            .getDownloadURL();
          const data = [...apps];
          data[index] = {
            ...data[index],
            icon: url,
            iconError: "",
          };
          setApps(data);
          setIsImageUploading(false);
        }
      );
    }
  };

  const handleEditImage = () => {
    document.getElementById("appImage").click();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!imageData && !imagePath) {
      return setErrors({ ...errors, image: "Please select an image." });
    } else if (!props.edit) {
      if (!imageData || !imagePath)
        return setErrors({ ...errors, image: "Please select an image." });
    }
    if (!name) {
      return setErrors({ ...errors, name: "Invalid value." });
    }

    let fileName;

    if (imageData) {
      fileName = new Date().getTime() + imageData.name;
      const uploadTask = storage.ref(`/images/${fileName}`).put(imageData);
      uploadTask.on(
        "state_changed",
        () => {},
        (err) => console.log(err),
        async () => {
          fileName = await storage
            .ref("images")
            .child(fileName)
            .getDownloadURL();
          if (props.edit) {
            //  edit
            await update(
              props.app._id,
              {
                name,
                icon: fileName,
                apps,
              },
              "smartapps"
            );
            handleClose();
          } else {
            // create
            await create(
              {
                name,
                icon: fileName,
                apps,
                createdAt: new Date().toISOString(),
              },
              "smartapps"
            );
            handleClose();
            // window.location.reload(true);
          }
        }
      );
    } else {
      fileName = imagePath;
      if (props.edit) {
        //  edit
        await update(
          props.app._id,
          {
            name,
            icon: fileName,
            apps,
          },
          "smartapps"
        );
        handleClose();
      }
    }
  };

  return (
    <Fragment>
      {props.edit ? (
        <ToolTipButton onClick={handleOpen} title="Edit" placement="top">
          <EditIcon color="primary" />
        </ToolTipButton>
      ) : (
        <Button color="primary" variant="contained" onClick={handleOpen}>
          Create New Smart App
        </Button>
      )}
      <Snackbar
        open={isImageUploading}
        autoHideDuration={6000}
        onClose={() => setIsImageUploading(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert variant="filled" severity="info" style={{ textAlign: "left" }}>
          <AlertTitle>Image Information</AlertTitle>
          Be patience your <strong>Image</strong> is uploading...
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="responsive-dialog-name"
      >
        <ToolTipButton
          title="Close"
          onClick={handleClose}
          btnClass={classes.closeDialog}
        >
          <CloseIcon color="primary" />
        </ToolTipButton>
        <DialogTitle id="responsive-dialog-name">Smart App Data</DialogTitle>

        <DialogContent>
          <form onSubmit={handleSubmit}>
            <div>
              <div onClick={handleEditImage} className={classes.head}>
                <input
                  name="appImage"
                  id="appImage"
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleInputFileChange}
                />
                <Image imagePath={imagePath} />
                {errors.image && (
                  <div style={{ textAlign: "center" }}>
                    <Typography variant="caption" color="error">
                      {errors.image}
                    </Typography>
                  </div>
                )}
              </div>
              <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={errors.name ? true : false}
                helperText={errors.name}
                label="Name"
                type="text"
                pattern="^\w+(\s+\w+)*$"
              />
            </div>
            <div>
              {apps.map((app, index) => (
                <Paper key={index} className={classes.appBox}>
                  <span
                    onClick={() =>
                      document.getElementById(`appImage${app.index}`).click()
                    }
                  >
                    <Image imagePath={app.icon} small />
                    <input
                      name="appImage"
                      id={`appImage${app.index}`}
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleAppImageChange.bind(this, app.index)}
                    />
                    {app.iconError && (
                      <div style={{ textAlign: "center" }}>
                        <Typography variant="caption" color="error">
                          {app.iconError}
                        </Typography>
                      </div>
                    )}
                  </span>
                  <TextField
                    className={classes.appField}
                    value={app.name}
                    onChange={handleChangeApp.bind(this, app.index)}
                    error={app.nameError ? true : false}
                    helperText={app.nameError}
                    name="name"
                    label="Name"
                    pattern="^\w+(\s+\w+)*$"
                  />
                  <TextField
                    className={classes.appField}
                    value={app.url}
                    onChange={handleChangeApp.bind(this, app.index)}
                    error={app.urlError ? true : false}
                    helperText={app.urlError}
                    name="url"
                    label="URL"
                    type="url"
                  />

                  <ToolTipButton
                    onClick={handleRemoveApp.bind(this, app.index)}
                    title="Delete App"
                    placement="top"
                  >
                    <CloseIcon color="primary" />
                  </ToolTipButton>
                </Paper>
              ))}
            </div>

            {errors.app && (
              <div style={{ textAlign: "center" }}>
                <Typography variant="caption" color="error">
                  {errors.app}
                </Typography>
              </div>
            )}

            <div className={classes.bottom}>
              <ToolTipButton
                onClick={handleAddApp}
                title="Create New App"
                placement="top"
              >
                <AddIcon color="primary" />
              </ToolTipButton>
              <Button variant="contained" color="primary" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

AppDialog.propTypes = {
  edit: PropTypes.bool,
  app: PropTypes.object,
};

export default AppDialog;
